<script>
import Widget from "./widget";
import PlayersChart from "@/components/application/PlayersChart";
import ApplicationIncomeChart from "@/components/application/ApplicationIncomeChart";

/**
 * Dashboard component
 */
export default {
  page: {
    title: "داشبورد",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Widget,
    PlayersChart,
    ApplicationIncomeChart,
  },
  data() {
    return {
      title: "داشبورد",
      items: [
        {
          text: "داشبورد",
          active: true,
        },
      ],
      dashboardData: JSON.parse(
        JSON.stringify(this.$store.state.dashboard.dashboardData)
      ),
    };
  },
  mounted() {
    this.$axios.get("/dashboard-data").then((res) => {
      this.dashboardData = res.data;
      this.updateDetail();
    });
  },
  methods: {
    updateDetail() {
      this.$store.dispatch("dashboard/updateDashboardData", this.dashboardData);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <template v-if="$store.state.dashboard.dashboardData.total">
      <div class="row">
        <div class="col-12">
          <Widget />
        </div>
        <div class="col-12">
          <PlayersChart />
        </div>
        <div class="col-12">
          <ApplicationIncomeChart chart-type="bar" />
        </div>
      </div>
    </template>
  </Layout>
</template>
